export const SystemCodeMap = {
  emergencyDrillPlanStatus: '_SYS_EM_10',
  emergencyDrillPlanStatusList: {
    draft: '_SYS_EM_10_1',
    inReview: '_SYS_EM_10_2',
    over: '_SYS_EM_10_3',
    back: '_SYS_EM_10_4',
    delete: '_SYS_EM_10_5'
  },
  emergencyResponseLevel: '_SYS_EM_9',
  drillRecordQuzi: '_SYS_EM_7',
  emergencyDrillRecordStatus: '_SYS_EM_8',
  emergencyClassify: '_SYS_EM_4',
  emergencyPlanStatus: '_SYS_EM_3',
  countryList: '_SYS_A1',
  corporateStructureTypeList: '_SYS_A8',
  corporateStructureType: {
    masterCompany: '_SYS_A8_0',
    company: '_SYS_A8_1',
    department: '_SYS_A8_2',
    facility: '_SYS_A8_9',
    division: '_SYS_A8_3',
    region: '_SYS_A8_4',
    group: '_SYS_A8_5',
    branchCompany: '_SYS_A8_6',
    statisticsOfWaste: '_SYS_A8_7',
    headquarters: '_SYS_A8_8'
  },
  discontinuedStatus: '_SYS_GMP_STOP_REPORT_STATUS',
  inspectionCategory: '_SYS_IC',
  GMPInspectionType:'_SYS_DS',
  classStatusList: '_TRAINING_AG',
  classStatus: {
    pending: '_TRAINING_AG_1',
    live: '_TRAINING_AG_2',
    ended: '_TRAINING_AG_3',
    completed: '_TRAINING_AG_3',
    aboutToStart: '_TRAINING_AG_4',
    processing: '_TRAINING_AG_5'
  },
  instructorTypeList: '_TRAINING_AE',
  instructorType: {
    fullTimeEmployee: '_TRAINING_AE_1',
    contractor: '_TRAINING_AE_2',
    thirdParty: '_TRAINING_AE_3'
  },
  lessonTrainingTypeList: '_TRAINING_AC',
  lessonTypeList: '_TRAINING_AD',
  locationType: {
    classroom: '_SYS_AB_11'
  },
  statusList: '_SYS_A9',
  status: {
    active: '_SYS_A9_1',
    inactive: '_SYS_A9_2',
    processing: '_SYS_A9_3',
    readOnly: '_SYS_A9_4',
    pending: '_SYS_A9_3',
  },
  inspectionStatusList: '_SYS_B2',
  inspectionStatus: {
    pending: '_SYS_B2_1',
    todo: '_SYS_B2_2',
    missed: '_SYS_B2_3',
    completed: '_SYS_B2_4',
    draft: '_SYS_B2_5',
    closed: '_SYS_B2_6',
    temp: '_SYS_B2_7'
  },

  BBSOStatusList: '_SYS_B2',
  BBSOStatus: {
    draft: '_SYS_B2_5',
    complete: '_SYS_B2_4'
  },
  BBSOTypeList: '_SYS_BS',
  BBSOType: {
    adHocBbso: '_SYS_BS_AH',
    scheduledBbso: '_SYS_BS_SC',
  },


  timeUnitList: '_SYS_AW',
  gender: '_SYS_A3',
  // jobGrade: '_SYS_AP',
  lessonType: '_TRAINING_AD',
  trainingClassStatus: '_TRAINING_AG',
  timeUnit: {
    hour: '_SYS_AW_1',
    day: '_SYS_AW_2',
    week: '_SYS_AW_3',
    month: '_SYS_AW_4',
    year: '_SYS_AW_5',
    once: '_SYS_AW_6',
  },
  trainingAttendanceStatusList: '_TRAINING_AH',
  trainingAttendanceStatus: {
    incomplete: '_TRAINING_AH_1',
    complete: '_TRAINING_AH_2',
    exempt: '_TRAINING_AH_3',
    expired: '_TRAINING_AH_4',
    pass: '_TRAINING_AH_5',
    fail: '_TRAINING_AH_6',
    unrecord: '_TRAINING_AH_7'
  },
  reasonList: '_TRAINING_AI',
  reason: {
    onleave: '_TRAINING_AI_1',
    other: '_TRAINING_AI_2'
  },
  controlLevelList: '_SYS_CL1',
  riskRatingList: '_SYS_RR',
  riskLevelList: 'RISK_LEVEL',
  riskRating: {
    hight: '_SYS_RR_1',
    medium: '_SYS_RR_2',
    low: '_SYS_RR_3',
    negligible: '_SYS_RR_4',
    lowMedium: '_SYS_RR_5',
    highMedium: '_SYS_RR_6',
    extreme: '_SYS_RR_7'
  },
  riskParametersList: '_SYS_R1',
  riskParameters: {
    likelyhood: '_SYS_R1_1',
    severity: '_SYS_R1_2'
  },
  assessmentTypeList: '_SYS_R2',
  assessmentType: {
    hazardIdentificationAndRiskAssessment: '_SYS_R2_1',
    workplaceHazardAnalysis: '_SYS_R2_2',
    jobHazardAnalysis: '_SYS_R2_3'
  },
  assessmentModeList: '_SYS_R3',
  assessmentMode: {
    FR: '_SYS_R3_1',
    SR: '_SYS_R3_2',
    numberOfIncident: '_SYS_R3_3',
    others: '_SYS_R3_4',
  },
  correctiveActionTaskStatusList: '_SYS_CA',
  correctiveActionTaskStatus: {
    confirmed: '_SYS_CA_1',
    unconfirmed: '_SYS_CA_2',
  },
  jobTaskTypeList: '_SYS_JT1',
  jobTaskType: {
    Administration: '_SYS_JT1_1',
    Inspection: '_SYS_JT1_2',
    businessTrip: '_SYS_JT1_3',
    training: '_SYS_JT1_4',
    other: '_SYS_JT1_5'
  },
  jobTaskSubTypeList: '_SYS_JT2',
  jobTaskLocationList: '_SYS_JT3',
  jobTaskServiceLifeCycleList: '_SYS_JT4',
  jobTaskStaffTypeList: '_SYS_JT5',
  jobTaskStaffType: {
    employee: '_SYS_JT5_A',
    // passenger: '_SYS_JT5_B',
    contractor: '_SYS_JT5_C',
    outsourcer: '_SYS_JT5_D',
    visitor: '_SYS_JT5_E',
    // employeeFamily: '_SYS_JT5_F',
    otherStakeholder: '_SYS_JT5_G'
  },
  jobTaskCycleList: '_SYS_JT6',
  jobTaskEnvironmentList: '_SYS_JT7',
  jobTaskToolList: '_SYS_JT8',
  jobTaskMaterialList: '_SYS_JTE',
  jobTaskQualificationList: '_SYS_JTF',
  jobTaskSituationList: '_SYS_JT9',
  jobTaskEngineeringControlList: '_SYS_JT10',
  jobTaskManagementControlList: '_SYS_JT11',
  jobTaskPersonalProtectiveEquipmentList: '_SYS_JT12',
  jobTaskLocationOther: '_SYS_JT3_Other',
  jobTaskEnvironmentOther: '_SYS_JT7_Other',
  jobTaskToolOther: '_SYS_JT8_Other',
  jobTaskMaterialOther: '_SYS_JTE_Other',
  jobTaskQualificationOther: '_SYS_JTF_Other',
  jobTaskEngineeringControlOther: '_SYS_JT10_Other',
  jobTaskManagementControlOther: '_SYS_JT11_Other',
  jobTaskPersonalProtectiveEquipmentOther: '_SYS_JT12_Other',
  jobTaskUpdateFromList: '_SYS_JT13',
  jobTaskUpdateFrom: {
    correctiveAction: '_SYS_JT13_1',
    conductJobHazardAnalysis: '_SYS_JT13_2',
    jobTaskSetup: '_SYS_JT13_3'
  },
  hazardTypeList: '_SYS_SO_1',
  hazardType: {
    commutingRoadAccident: '_SYS_SO_1_AU', // 上下班公路交通事故
    commutingRailwayTrafficAccident: '_SYS_SO_1_AV', // 上下班鐵路交通事故
    commutingCabinAircraftTrafficAccident: '_SYS_SO_1_AW', // 上下班船艙、航空器交通事故
    commutingOtherTrafficAccident: '_SYS_SO_1_AX', // 上下班其他交通事故
    nonCommutingRailwayTrafficAccident: '_SYS_SO_1_AY', // 非上下班鐵路交通事故
    nonCommutingRoadAccident: '_SYS_SO_1_AZ', // 非上下班公路交通事故
    nonCommutingCabinAircraftTrafficAccident: '_SYS_SO_1_BA', // 非上下班船艙、航空器交通事故
    nonCommutingOtherTrafficAccident: '_SYS_SO_1_BB', // 非上下班其他交通事故
  },
  hazardTypeOther: '_SYS_SO_1_Other',
  cardsTypeList: 'EHS_THREE_CARDS_MANAGE',  //三卡卡片类型
  safetyMarkList: 'SAFE_SIGN',  //安全标志
  scheduleTypeList: '_SYS_AV',
  scheduleType: {
    inspectionScheduling: '_SYS_AV_1',
    auditScheduling: '_SYS_AV_2',
    incidentScheduling: '_SYS_AV_3',
    scheduledInspection: '_SYS_AV_5',
    schedulingBBSO:'_SYS_AV_SC'
  },
  activityStatusList: '_SYS_AY',
  activityStatus: {
    completed: '_SYS_AY_4',
    pending: '_SYS_AY_5',
    live: '_SYS_AY_6',
    discontinued: '_SYS_AY_7'
  },
  teamTypeList: '_SYS_EM_1',
  taskStatusList: '_SYS_PL1',
  taskStatus: {
    inProgress: '_SYS_PL1_1', // 進行中
    completed: '_SYS_PL1_2', // 已结束
    cancelled: '_SYS_PL1_3', // 撤銷
    pending: '_SYS_PL1_4', // 待定
    verifying: '_SYS_PL1_5', // 驗證中
    signing: '_SYS_PL1_6', // 簽核中
    caseClosed: '_SYS_PL1_7', // 結案
    draft: '_SYS_PL1_8', // 草稿
    signed: '_SYS_PL1_9', // 已簽核
    unsigned: '_SYS_PL1_A', // 未簽核
    reporting: '_SYS_PL1_B', // 通報中
    reviewing: '_SYS_PL1_C', // 受理中
    underInvestigation: '_SYS_PL1_D', // 調查中
    underImprovement: '_SYS_PL1_E', // 改善中
    waiting: '_SYS_PL1_F', // 接受中
    overdue: '_SYS_PL1_G', // 逾期
    assigning: '_SYS_PL1_H', // 指派中
    review: '_SYS_PL1_I', // 審核中
    finalReview: '_SYS_PL1_J', // 最終審核
    close: '_SYS_PL1_T1', // 关闭中
    invalid: '_SYS_PL1_T2', // 无效
    nullify: '_SYS_PL1_K',
    approvalExtension:"_SYS_PL1_M",//延期审核中
    closed: '_SYS_PL5_6', //关闭
    firstLevelApproval: '_SYS_PL5_2', //一级审批
    secondLevelApproval: '_SYS_PL5_3', //二级审批
    approve: '_SYS_PL5_4', //已通过
    rejected: '_SYS_PL5_5', //已驳回

    dirt: '_SYS_FC_1', // 污垢/垃圾
    mold: '_SYS_FC_2', // 霉菌
    operationSpecification: '_SYS_FC_3', // 人员操作规范
    pestsControl: '_SYS_FC_4', // 害虫控制
    factoryMaintenance: '_SYS_FC_5', // 厂房与维护
    processControl: '_SYS_FC_6', // 工艺与控制（程序）
    safetyEnvironment: '_SYS_FC_7', // 安全与环境
    record: '_SYS_FC_8', // 记录
    redLine: '_SYS_FC_9', // 红线问题
    redModl: '_SYS_FC_10', // 霉菌 - 红线
    redPestsControl: '_SYS_FC_11', // 害虫控制 - 红线
  },

  contractorTaskStatusList: '_STATUS_S1',
  contractorStatus: {
    draft: '_STATUS_S1_5', // 草稿
    active: '_STATUS_S1_1', //有效
    inactive: '_STATUS_S1_2', //无效
    blacklist: '_STATUS_S1_3', //黑名单
    underReview: '_STATUS_S1_6', //待审批
  },
  contractorPersonnelStatus: {
    draft: '_SYS_A9_5', // 草稿
    active: '_SYS_A9_1', //有效
    inactive: '_SYS_A9_2', //无效
    blacklist: '_SYS_A9_7', //黑名单
    underReview: '_SYS_A9_6', //待审批
  },

  contractorProjectStatus: {
    draft: '_SYS_A9_PROJECT_1', // 草稿
    progressing: '_SYS_A9_PROJECT_2', // 進行中
    closed: '_SYS_A9_PROJECT_3', //关闭
    underReview: '_SYS_A9_PROJECT_4', //待审批
    ervaluation: '_SYS_A9_PROJECT_5', //待评估
    canceled: '_SYS_A9_PROJECT_6', // 暂停
  },


  planningListFrequencyList: '_SYS_TM_PD',
  planningListFrequency: {
    direct: '_SYS_TM_PD_0',
    hourly: '_SYS_TM_PD_1',
    daily: '_SYS_TM_PD_2',
    weekly: '_SYS_TM_PD_3',
    monthly: '_SYS_TM_PD_4',
    yearly: '_SYS_TM_PD_5',
    once: '_SYS_TM_PD_6',
  },
  endDateTypeList: '_SYS_PL',
  endDateType: {
    none: '_SYS_PL_1',
    byDate: '_SYS_PL_2',
    afterRecurrences: '_SYS_PL_3',
  },
  dailyRecurrenceList: '_SYS_PL2',
  dailyRecurrence: {
    once: '_SYS_PL2_1',
    hour: '_SYS_PL2_2',
    minute: '_SYS_PL2_3'
  },
  gmpOther: '_SYS_GMP_AF',
  monthlyRecurrenceList: '_SYS_PL3',
  monthlyRecurrence: {
    first: '_SYS_PL3_1',
    second: '_SYS_PL3_2',
    third: '_SYS_PL3_3',
    forth: '_SYS_PL3_4',
    last: '_SYS_PL3_5',
    day: '_SYS_PL3_6',
  },
  weekdaysList: '_SYS_PL4',
  weekdays: {
    monday: '_SYS_PL4_1',
    tuesday: '_SYS_PL4_2',
    wednesday: '_SYS_PL4_3',
    thursday: '_SYS_PL4_4',
    friday: '_SYS_PL4_5',
    saturday: '_SYS_PL4_6',
    sunday: '_SYS_PL4_7',
    weekday: '_SYS_PL4_8'
  },
  taskTypeList: '_SYS_ST3',
  safetyKPIList: '_SYS_PL1',
  deviationSourceList: '_SYS_PL1',
  deviationCategoryList: '_SYS_PL1',
  workStatusList: '_SYS_PL5',
  auditType: '_SYS_WH_8',
  lifeSavingRulesList: '_SYS_WH_19',
  taskTypes: {
    // 風險與評估
    riskAssessment: '_SYS_ST3_1',
    investigation: '_SYS_ST3_2',
    // 应急管理
    
    emergencyInvestigation:'',

    // 事故管理
    incidentManagement: '_SYS_ST3_3',
    incidentInvestigation: '_SYS_ST3_4',
    correctiveAction: '_SYS_ST3_5',
    // 法規鑑別
    regulationIdentification: '_SYS_ST3_6',
    regulationDistributedIdentification: '_SYS_ST3_7',
    regulationCorrectiveAction: '_SYS_ST3_8',
    // 巡查管理
    reportedIssue: '_SYS_ST3_9',
    scheduledInspection: '_SYS_ST3_A',
    nonScheduledInspection: '_SYS_ST3_B',
    inspectionCorrectiveAction: '_SYS_ST3_C',
    govInspection: '_SYS_ST3_F',
    govInspectionCorrectiveAction: '_SYS_ST3_F1',
    // 应急管理
    emergencyDrillPlan: '_SYS_ST3_H',
    // BBSO
    adHocBbso: '_SYS_ST3_AH',
    scheduledBbso: '_SYS_ST3_SC',
    scheduledBbsoCorrectiveAction: '_SYS_ST3_SC_CA',
  },
  contractorTaskTypes: {
    
    // 承包商管理
    contractorManagement: '_SYS_ST3_I',  //承包商信息审批
    contractorPersonnel: '_SYS_ST3_J',  //承包商人员审批
    contractorPersonnelBatch: '_SYS_ST3_J_1',  //承包商人员审批-批量审批
    workManagement: '_SYS_ST3_K',  //作业审批
    workScheduling: '_SYS_ST3_L',  //作业计划检查
    specialWork:'_SYS_ST3_M',  //特种作业审批
    projectManagement: '_SYS_ST3_R',  //项目审批
    workImmediatelyInspection: '_SYS_ST3_O', // 作业立即检查
    workScheduled: '_SYS_ST3_L_CA', // 作业申请整改
    workSpecialScheduled: '_SYS_ST3_N_CA', // 特种作业整改
    workAdScheduled: '_SYS_ST3_O_CA', // 立即检查作业申请整改
    workAdSpecialScheduled: '_SYS_ST3_P_CA', // 立即检查特种作业整改
    workAdSpecialScheduled2: '_SYS_ST3_P', // 立即检查特种作业整改2
  },

  contractorStatusList: '_SYS_PL5',  //承包商状态

  responsibilityTypeList: '_SYS_ST1', // 負責人員類型
  responsibilityTypes: {
    taskManager: '_SYS_ST1_1', // 任務負責人
    evaluationParticipant: '_SYS_ST1_2', // 評估參與者
    evaluationTeam: '_SYS_ST1_3', // 評論團隊
    proxySigner: '_SYS_ST1_4', // 簽核代理人
    signer: '_SYS_ST1_5', // 簽核人員
    creator: '_SYS_ST1_6', // 發起人
    assignee: '_SYS_ST1_7', // 執行者
    reviewTeam: '_SYS_ST1_8', // 評論人員
    verifier: '_SYS_ST1_9', // 驗證人
    // parallelSigner: '_SYS_ST1_A', // 平行傳會簽核人員
    // parallelProxySigner: '_SYS_ST1_B', // 平行傳會簽核代理人
    incidentReportCreatedBy: '_SYS_ST1_C', // 事故通報人
    incidentInvolvedPerson: '_SYS_ST1_D', // 事故當事人
  },
  reportStatusList: '_SYS_CF',
  reportStatus: {
    confirmed: '_SYS_CF_1',
    unconfirmed: '_SYS_CF_2'
  },
  riskOpportunitySourceList: '_SYS_R4',
  riskOpportunityRiskTreatmentList: '_SYS_R5',
  riskModuleList: '_SYS_MO',
  taskActionHistoryList: '_SYS_ST4',
  taskActionHistory: {
    claimTask: '_SYS_ST4_7'
  },
  correctiveActionTypeList: '_SYS_BA',
  incidentActionTypeList: '_SYS_AT',
  logTypeList: '_SYS_A7',
  // reportEntityList: '_SYS_RSK_R',
  logicAnswerTypeList: '_SYS_AM',
  importanceList: '_SYS_GMP_AD',
  inspectionLevelList: '_SYS_GMP_AC',
  redLineCategoryList: '_SYS_GMP_AE',
  logicAnswerType: {
    yes: '_SYS_AM_1',
    no: '_SYS_AM_2',
    unknown: '_SYS_AM_3',
  },
  bbsoAnswerTypeList: '_SYS_AO',
  bbsoAnswerType: {
    safe: '_SYS_AO_1',
    atRisk: '_SYS_AO_2',
    na: '_SYS_AO_3',
  },
  dutyList: '_INCIDENT_D1',
  duty: {
    involvedPerson: '_INCIDENT_D1_5'
  },
  incidentInvestigationStatusList: {
    inProgress: '_SYS_PL1_1',
    signing: '_SYS_PL1_6',
    caseClosed: '_SYS_PL1_7',
  },
  incidentTypeList: '_INCIDENT_D2',
  incidentType: {
    // occupationalAccident: '_INCIDENT_D2_1', // 職業災害
    accident: '_INCIDENT_D2_2', // 一般事故
    nearMiss: '_INCIDENT_D2_3', // 虛驚事件
    filing: '_INCIDENT_D2_4' // 存參
  },
  // weatherOption: '_report_weather_A1',
  weatherTypeList: '_CSPCINCIDENT_A3',
  weatherType: {
    clear: '_CSPCINCIDENT_A3_01',
    cloudy: '_CSPCINCIDENT_A3_02',
    dusty: '_CSPCINCIDENT_A3_03',
    fog: '_CSPCINCIDENT_A3_04',
    lightning: '_CSPCINCIDENT_A3_05',
    rain: '_CSPCINCIDENT_A3_06',
    roughSeas: '_CSPCINCIDENT_A3_07',
    thunderStorm: '_CSPCINCIDENT_A3_08',
    typhoon: '_CSPCINCIDENT_A3_09',
    windy: '_CSPCINCIDENT_A3_10',
    other: '_CSPCINCIDENT_A3_11',
  },
  bbsoWeatherTypeList: '_BBSO_A1',
  bbsoWeatherType: {
    sunny: '_BBSO_A1_01',
    cloudy: '_BBSO_A1_02',
    rainy: '_BBSO_A1_03',
    snowy: '_BBSO_A1_04',
    dusty: '_BBSO_A1_05',
    foggy: '_BBSO_A1_06',
    thunderstorm: '_BBSO_A1_07',
    tornadoes: '_BBSO_A1_08',
    hurricanes: '_BBSO_A1_09',
    typhoons: '_BBSO_A1_10',
    winterStorms: '_BBSO_A1_11',
    blizzards: '_BBSO_A1_12',
    floods: '_BBSO_A1_13',
    others: '_BBSO_A1_14',
  },
  injurySeverity: '_report_injured_A2',
  transportationList: '_INCIDENT_TP', // 交通工具
  transportation: {
    car: '_INCIDENT_TP_1',
    locomotive: '_INCIDENT_TP_2',
    bicycle: '_INCIDENT_TP_3',
    walk: '_INCIDENT_TP_4',
    pubicTransportation: '_INCIDENT_TP_5',
  },
  lossTypeList: '_INCIDENT_DA',
  lossType: {
    otherLoss: '_INCIDENT_DA_1', // 其他損失
    facilityLoss: '_INCIDENT_DA_2', // 器材損失
  },
  restrictionTypeList: '_INCIDENT_DE',
  // lossTypeClassification: '_INCIDENT_DD',
  partOfBodyAffectedList: '_report_injured_A1',
  partOfBodyAffected: {
    other: '_report_injured_A1_Other'
  },
  injuryNatureCodeList: '_SYS_WH_18',
  indirectCauseList: '_INCIDENT_D3',
  unsafeConditionList: '_INCIDENT_D3_1',
  unsafeConditionOther: '_INCIDENT_D3_1_Other',
  unsafeBehaviorList: '_INCIDENT_D3_2',
  rootCauseList: '_INCIDENT_D4',
  rootCauseOther: '_INCIDENT_D4_Other',
  reportTypeList: '_INCIDENT_D5',
  reportType: {
    // personalReport: '_INCIDENT_D5_1',
    // occupationalAccident: '_INCIDENT_D5_2',
    abnormalEventReport: '_INCIDENT_D5_3',
  },
  incidentCategoryList: '_INCIDENT_D6',
  accidentCategoryList: '_SYS_WH_9',
  incidentQualityCategoryList: '_SYS_INCIDENT_QUALITY',
  supplyChainProcessList: '_SYS_WH_10',
  locationRangeList: '_SYS_WH_11',
  lossCountList: '_SYS_WH_13',
  injuryCountList: '_SYS_WH_12',
  incidentCategoryOther: '_INCIDENT_D6_Other',
  incidentCategoryChemicalRelease: '_INCIDENT_D6_Chemical_Release',
  vehicleAccidentCode: '_INCIDENT_D6_1',
  potentialPrimaryCauseList: '_SYS_WH_14',
  otherInternalCause: '_SYS_WH_14_12',
  otherExternalCause: '_SYS_WH_14_13',  
  collisionTypeList: '_SYS_WH_15',
  carTypeList: '_SYS_WH_16',
  carOwnerList: '_SYS_WH_17',
  isDrivierTraining: '_INCIDENT_D7',
  // incidentLossTimeClassificationList: '_INCIDENT_D6_3',
  // workingPlaceList: '_INCIDENT_D7_1',
  // notWorkingPlaceList: '_INCIDENT_D7_2',
  involvedTypeList: '_INCIDENT_D8',
  reportingLevelList: '_INCIDENT_D9',
  signActionList: '_SYS_TS2',
  signAction: {
    ok: '_SYS_TS2_1',
    reject: '_SYS_TS2_2'
  },
  parallelSignActionList: '_SYS_PL6',
  parallelSignAction: {
    ok: '_SYS_PL6_1',
    reject: '_SYS_PL6_2',
    processing: '_SYS_PL6_3',
    reassignTo: '_SYS_PL6_4'
  },
  taskVersionContentList: '_INCIDENT_HS_D',
  taskVersionUpdateUpdateFromList: '_INCIDENT_HS_UF',
  violationList: '_INCIDENT_DF',
  violation: {
    regulatoryRequirement: '_INCIDENT_DF_1', // 法規
    OSHM: '_INCIDENT_DF_2', // 職安衛室管理系統規範
    companyRules: '_INCIDENT_DF_3', // 公司規定
    other: '_INCIDENT_DF_4', // 可能造成其他潛在危害
    noViolation: '_INCIDENT_DF_5', // 無違反
  },
  verificationNextActionList: '_INCIDENT_DG',
  verificationNextAction: {
    reject: '_INCIDENT_DG_1',
    postpone: '_INCIDENT_DG_2',
  },
  laborInsuranceUnderwritingResultList: '_INCIDENT_DB',
  disabilityInjuryTypeList: '_INCIDENT_DC',
  corporateStructureContactsTitleList: '_SYS_CB',
  orgTypeList: '_SYS_A12',
  shiftCodeList: '_SYS_AQ',
  regulationApplicableStatusList: '_SYS_IR_AS',
  regulationApplicableStatus: {
    applicable: '_SYS_IR_AS_1',
    notApplicable: '_SYS_IR_AS_2',
    notIdentified: '_SYS_IR_AS_4',
  },
  regulationActivityStatusList: '_SYS_IR_AT',
  regulationActivityStatus: {
    waiting: '_SYS_IR_AT_1', // 即將開始
    progressing: '_SYS_IR_AT_2', // 進行中
    completed: '_SYS_IR_AT_3', // 完成
    overdue: '_SYS_IR_AT_4', // 逾期
    canceled: '_SYS_IR_AT_5', // 終止
  },
  regulationStepStatusList: '_SYS_IR_SS',
  regulationStepStatus: {
    none: '_SYS_IR_SS_0',
    current: '_SYS_IR_SS_1',
    processed: '_SYS_IR_SS_2',
  },
  regulationLogTypeList: '_SYS_IR_LG',
  regulationLogType: {
    activity: '_SYS_IR_LG_1',
    acceptTask: '_SYS_IR_LG_2',
    forwardTask: '_SYS_IR_LG_3',
    submit: '_SYS_IR_LG_4',
    approve: '_SYS_IR_LG_5',
    reject: '_SYS_IR_LG_6',
    assignCorrective: '_SYS_IR_LG_7',
    acceptCorrective: '_SYS_IR_LG_8',
    notify: '_SYS_IR_LG_9',
  },
  regulationTaskStatusList: '_SYS_IR_ST',
  regulationTaskStatus: { // 鑑別任務
    waiting: '_SYS_IR_ST_1', // 接受中
    toAssign: '_SYS_IR_ST_11', // 指派中
    improving: '_SYS_IR_ST_12', // 改善中 -> 進行中
    identifying: '_SYS_IR_ST_2', // 鑑別中 -> 進行中
    signing: '_SYS_IR_ST_3', // 審核中 -> 簽核中
    caseClosed: '_SYS_IR_ST_4', // 完成 -> 結案
    canceled: '_SYS_IR_ST_5', // 取消 -> 撤銷
  },
  regulationCallOutStatusList: '_SYS_IR_CO',
  regulationCallOutStatus: { // 分工鑑別
    identifying: '_SYS_IR_CO_1', // 鑑別中
    completed: '_SYS_IR_CO_2', // 完成
    overdue: '_SYS_IR_CO_3', // 逾期
    canceled: '_SYS_IR_CO_4',
  },
  regulationPassStatusList: '_SYS_IR_PS',
  regulationPassStatus: {
    passed: '_SYS_IR_PS_1',
    notPassed: '_SYS_IR_PS_2',
    notIdentified: '_SYS_IR_PS_4'
  },
  regulationContentCategoryList: '_SYS_IR_IC',
  regulationContentCategory: {
    last: '_SYS_IR_IC_1',
    current: '_SYS_IR_IC_2',
    callOut: '_SYS_IR_IC_3',
  },
  regulationImprovementCategoryList: '_SYS_IR_CC',
  regulationImprovementCategory: {
    immediate: '_SYS_IR_CC_1',
    postponed: '_SYS_IR_CC_2',
  },
  formManagementTypeList: '_SYS_FT',
  formManagementType: {
    authorization: '_SYS_FT_Auth', // 安全
    inspection: '_SYS_FT_Insp', // 環境
    bbso: '_SYS_FT_Bbso', // 其他
  },
  questionBankQuestionTypeList: '_SYS_AN',
  questionBankQuestionType: {
    safety: '_SYS_AN_1', // 安全
    environmental: '_SYS_AN_2', // 環境
    other: '_SYS_AN_3', // 其他
    bbso: '_SYS_AN_5', // 其他
  },
  questionBankResponseTypeList: '_SYS_AK',
  questionBankResponseType: {
    shortText: '_SYS_AK_1', // 短文本
    longText: '_SYS_AK_2', // 長文本
    numeric: '_SYS_AK_3', // 數字
    logical: '_SYS_AK_7', // 邏輯 - 是/否/未知
    dropdownSingle: '_SYS_AK_8', // 下拉式選項 - 單選
    dropdownMultiple: '_SYS_AK_9', // 下拉式選項 - 多選
    bbso: '_SYS_AK_12',
  },
  announcementLabelList: '_SYS_ANNOUNCEMENT_1',
  announcementTypeList: '_SYS_BU',
  announcementType: {
    draft: '_SYS_BU_1', // 草稿
    published: '_SYS_BU_2', // 已發佈
  },
  inspectionAndAuditTypeList: '_SYS_BS',
  inspectionAndAuditType: {
    aramarkIssueReporting: '_SYS_BS_8',
    aramarkGeneralInspection: '_SYS_BS_9',
    aramarkImmediateInspection: '_SYS_BS_10',
    aramarkGovInspectionReporting: '_SYS_BS_A',
    adHocBbso: '_SYS_BS_AH',
    scheduledBbso: '_SYS_BS_SC',
    gmpCnAdHocInspection:'_SYS_BS_13',//立即gmp检查
    gmpCnSchedulingInspection:'_SYS_BS_14',//计划gmp检查   
  },
  inspectionObjectTypeList: '_SYS_AA',
  inspectionObjectTypeOther: '_SYS_AA_Z',
  deviationTypeList: '_SYS_B1',
  inspectionRiskLevelList: '_SYS_AX',
  inspectionRiskRatingList: '_SYS_AX',
  inspectionRiskRating: {
    high: '_SYS_AX_1',
    medium: '_SYS_AX_2',
    low: '_SYS_AX_3',
  },
  inspectionIssueClassificationList: '_SYS_DC',
  inspectionIssueRecordStatusList: '_SYS_BE',
  // inspectionType: '_SYS_BL',
  inspectionIssueRecordStatus: {
    review: '_SYS_BE_4',
    underImprovement: '_SYS_BE_5',
    completed: '_SYS_BE_6',
    caseClosed: '_SYS_BE_7',
    invalid: '_SYS_BE_8',
    inProgress: '_SYS_BE_9'
  },
  correctiveActionModeList: '_SYS_CA_AM',
  correctiveActionMode: {
    assignTask: '_SYS_CA_AM_1',
    immediateCorrection: '_SYS_CA_AM_2',
  },
  investigationCauseList: '_SYS_B5',
  deviationSeverityList: '_SYS_B9',
  deviationSeverity: {
    compliance: '_SYS_B9_5',
    nonCompliance: '_SYS_B9_2',
    naSeverity: '_SYS_B9_6',
  },
  inspectionMethodList: '_SYS_IM',
  inspectionMethod: {
    selectForms: '_SYS_IM_1',
    enterFindingsDirectly: '_SYS_IM_2'
  },
  taskSendingMethodList: '_SYS_B1C1',
  taskSendingMethod: {
    sendingByOrganization: '_SYS_B1C1_2',
    sendingByGroup: '_SYS_B1C1_3'
  },
  inspectionObjectStatusList: '_SYS_B6',
  inspectionObjectStatus: {
    incomplete: '_SYS_B6_1',
    completed: '_SYS_B6_2',
  },
  complianceDocumentClassificationTypeList: '_SYS_CD_A1',
  complianceDocumentClassificationType: {
    classification: '_SYS_CD_A1_1',
    document: '_SYS_CD_A1_2'
  },
  complianceDocumentStatusList: '_SYS_CD_A2',
  complianceDocumentStatus: {
    valid: '_SYS_CD_A2_1',
    invalid: '_SYS_CD_A2_2',
    inapplicable: '_SYS_CD_A2_3'
  },
  gmpGfpStatus:'_SYS_GFP',
  complianceDocumentRenewReasonList: '_SYS_CD_A3',
  complianceDocumentRenewReason: {
    expire: '_SYS_CD_A3_1',
    majorIssues: '_SYS_CD_A3_2'
  },
  inspectionType: '_SYS_BS',
  scheduledInspectionTypeList: '_SYS_SI',
  scheduledInspectionType: {
    generalInspection: '_SYS_SI_GI',
    bbso: '_SYS_SI_BB',
  },
  govInspectionDepartmentLevel: '_SAFETY_HEALTH_INSPECT_5',
  govInspectionCrisisPrediction: '_SAFETY_HEALTH_INSPECT_A',
  govInspectionDepartment: '_SAFETY_HEALTH_INSPECT_6',
  // 新培训 
  trainingScheduleType: '_TRAINING_PLAN_LIST',
  trainingScheduleTypeList: {
    bySelection: '_TRAINING_PLAN_LIST_A',
    byJobs: '_TRAINING_PLAN_LIST_B',
    byRoles: '_TRAINING_PLAN_LIST_C'
  },
  lessonSchedulingStatus: '_TRAINING_PLAN_STATUS',
  lessonSchedulingStatusList: {
    pending: '_TRAINING_PLAN_STATUS_A',
    live: '_TRAINING_PLAN_STATUS_B',
    paused: '_TRAINING_PLAN_STATUS_C',
    closed: '_TRAINING_PLAN_STATUS_D',
    completed: '_TRAINING_PLAN_STATUS_E'
  },
  recordStatus: {
    pending: '_TRAINING_AK_1',
    overTime: '_TRAINING_AK_2',
    completed: '_TRAINING_AK_3',
    overFinished: '_TRAINING_AK_5',
    canceled: '_TRAINING_AK_6'
  },
  conferenceStatus: '_TRAINING_SI',
  conferenceStatusList: {
    pending: '_TRAINING_SI_1',
    live: '_TRAINING_SI_2',
    closed: '_TRAINING_SI_3',
  },
  trainingTaskType: '_SYS_EL_2',
  trainingTaskTypeList: {
    video: '_SYS_EL_2_1',
    test: '_SYS_EL_2_2',
    pdf: '_SYS_EL_2_3'
  },
  lessonSource: '_SYS_LS_A',
  trainingClassification: '_TRAINING_AM',
  trainingMethod: '_TRAINING_AN',
  maintenanceDept: '_TRAINING_AO',
  trainingStatusList: '_TRAINING_AK',
  lessonStatus: '_SYS_EL_3',
  trainingTypeList: '_TRAINING_AL',
  studyStatus: '_SYS_EL_5',
  questionType: '_SYS_EL_1',
  employeeStatus: '_SYS_BV',
  employeeStatusList: {
    on: '_SYS_BV_1',
    off: '_SYS_BV_2',
  },
  trainingFinishStatus: '_TRAINING_PA',
  roleList: '_SYS_EM_2',
  emergencyMetarialType: '_SYS_EM_5',
  emergencyStatus: '_SYS_EM_6',
  locationAttributeType: 'LOCATION_TYPE',
  spaceAttribute: 'EHS_SPACE',
  //announcementsMent list
  announcementsMentItem: '_SYS_SA_I',
  announcementsMentType: '_SYS_SA_AT',

  bbsoWorkPartyList: '_BBSO_B1',
  bbsoWorkParty: {
    regularEmployee: '_BBSO_B1_01',
    outsourcingLaborDispatch: '_BBSO_B1_02',
    contractor: '_BBSO_B1_03',
  },

  supplierRateList: '_RATE_R1',
  supplierStatusList: '_STATUS_S1',
  supplierTypeList: '_PARTY_TYPE',
  supplierEmployeeStatus: '_SYS_A9_PARTY',
  projectStatus: '_SYS_A9_PROJECT',
  riskR2: '_RATE_R2',
  jobStatus: '_SYS_JOB_status',
  jobStatusList: {
    draft: '_SYS_JOB_status_1',
    underReview: '_SYS_JOB_status_2',
    inProgress: '_SYS_JOB_status_3',
    closed: '_SYS_JOB_status_4',
    suspended: '_SYS_JOB_status_5',
    approved: '_SYS_JOB_status_6',
    expired: '_SYS_JOB_status_7',
    finalReview: '_SYS_JOB_status_8',
  },
  evaluationReview: '_SYS_EVA_R',
  evaluationStatus: '_SYS_EV',
  evaluationStatusList: {
    draft: '_SYS_EV_1',
    completed: '_SYS_EV_2'
  },
  specialOperationsType: 'SPECIAL_OPERATIONS_TYPE',
  jobType: '_SYS_JOB',
  potentialHazardsType: '_SYS_POTENTIAL_HAZARDS',
  safetyMeasuresType: 'SAFETY_MEASURES',
  personalProtectiveEquipmentType: 'PERSONAL_PROTECTIVE_EQUIPMENT',
  occupationType:'_SYS_OCCUPATION',
  documentType: '_SYS_DOCUMENT_TYPE',
  specilJobStatus: '_SYS_SPECIAL_JOB_status',
  contractorAllStatus: '_SYS_ALL',
  contractorTaskStatus: {
    firstLevelApproval: '_SYS_PL5_2',
    secondLevelApproval: '_SYS_PL5_3',
    approved: '_SYS_PL5_4',
    rejected: '_SYS_PL5_5',
    inProgress: '_SYS_PL1_1',
    review: '_SYS_PL1_I',
    verifying: '_SYS_PL1_5',
    underImprovement: '_SYS_PL1_E',
    caseClosed: '_SYS_PL1_7',
    closed: '_SYS_PL5_6',
  },
  spaceType: '_SYS_SPACE_TYPE',
  businessModule: 'business_module',
  feedbackType: 'feedback_type',
  auditCategory: '_SYS_WH_8',
  GMPFindingType:'_SYS_FC',
  dataRange: '_D_S',
  riskHeatModuleScope: '_SYS_RHM',//风险热力图数据范围（按模块多选）
  riskHeatModuleScopeStatus: {
    riskHeatInspection: '_SYS_RHM_1',
    riskHeatBbso: '_SYS_RHM_2',
    riskHeatContractor: '_SYS_RHM_3',
    riskHeatIncident: '_SYS_RHM_4',
    riskHeatRiskAssessment: '_SYS_RHM_5',
    riskHeatGmpAudit: '_SYS_RHM_6',
  },
  highRiskOperations:'_SYS_km_dw',//高风险作业类型
  // accidentSeverity: '_SYS_WH_1',
  // causeList: '_SYS_WH_6',
  // accidentType: '_SYS_A9_PARTY',

  // CAPA管理
  capaSourceCategoryList: '_SYS_CAPA_SC',
  completionStatusList: '_SYS_CAPA_CS', 
  capaSourceCategory: {
    internal: '_SYS_CAPA_SC_1',
    external: '_SYS_CAPA_SC_2',
  },
  capaTaskStatusList: '_SYS_PL1',
  findingLevelList: '_SYS_CAPA_FL',
  mainProcess: '_SYS_CAPA_MP',

  // 扫码隐患上报-上报人类型
  qrReporterTypeList: '_SYS_QR_REPORTER_TYPE',
  qrReporterType: {
    systemUser: '_SYS_QR_REPORTER_TYPE_1',
    nonSystemUser: '_SYS_QR_REPORTER_TYPE_2'
  },
};
